import { render, staticRenderFns } from "./StandardPolicyReissue.vue?vue&type=template&id=1bddee40&scoped=true&"
import script from "./StandardPolicyReissue.vue?vue&type=script&lang=js&"
export * from "./StandardPolicyReissue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bddee40",
  null
  
)

export default component.exports